export default "/img/PT.6ad343e1a7f0f38ec2f61b346961ecf4.png";